import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, LazyImage, MainHeading, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowBtnBrown, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../../ui/AllImages'
// import { ContactButton } from '../../ui/CustomElements'

import { useTranslation } from 'react-i18next'
import { clientsItems } from '../../projectData/Data'

const Clients = () => {
    const { t } = useTranslation()
    
    return (
        <>
            <ClientWapper className='container-fluid secClient common-space' id='clients'>
                <Container>
                    <Row className='client-row'>
                        <Col md={12} className='centerHeadContainer'>
                            <MainHeading className='main-heading mb-3 main-heading-choose'>
                                {t('clientHeading')}
                            </MainHeading>
                            <SpanStyled className='chooseDesc mb-4' size="22px">
                                {t('clientText')}
                            </SpanStyled>
                        </Col>
                        <Col md={12} className='clientsBoxWrapper'>
                            <Box className='clientGrid'>
                                {clientsItems.map((item, index) => (
                                    <Box className='clientGridImg' key={index}>
                                        {item.img}
                                    </Box>
                                ))}
                            </Box>
                        </Col>
                        
                    </Row>
                </Container>
                <Box className='stripe stripe1'></Box>
            </ClientWapper>
            
        </>
    )
}
const ClientWapper = styled.section`

    .clientGrid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 20px;
    }

    /* .clientGrid > :nth-child(-n+5) {
        grid-column: span 4; 
    }

    .clientGrid > :nth-child(n+6) {
        grid-column: span 5;
    } */
    .centerHeadContainer{
        display: flex;
        width: 100%;
        justify-content: center;
        padding-left: 200px;
        padding-right: 200px;
        flex-wrap: wrap;
        padding-bottom: 20px;
        & > *{
            text-align: center;
            width: 100%;

        }
    }
    /* item */
    .clientGridImg {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 150px;
        width: 100%;
        border-radius: 16px;
        background-color: transparent;
        border: 1px solid var(--text2);
        padding: 15px;
    }
    @media (max-width: 991px) {
        .centerHeadContainer{
            padding-left: calc(var(--bs-gutter-x) * .5);
            padding-right: calc(var(--bs-gutter-x) * .5);
        }
        .clientGrid {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
        
    }
    @media (max-width: 800px) {
        .clientGrid {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }
    
    @media (max-width: 767px) {
        .clientGrid {
            grid-template-columns: 1fr 1fr 1fr;
        }
        /* .clientGrid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
        }
        .clientGrid > :nth-child(-n+5) {
            grid-column: unset; 
        }

        .clientGrid > :nth-child(n+6) {
            grid-column: unset; 
        } */
    }
    @media (max-width: 575px) {
        /* .clientGrid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
        } */
        .clientGrid {
            grid-template-columns: 1fr 1fr;
        }
        
    }
    @media (max-width: 450px) {
        /* .clientGrid {
            grid-template-columns: repeat(1, 1fr);
            gap: 15px;
        } */
        
    }
    @media (max-width: 350px) {
        .clientGrid {
            gap: 10px;
        }
        
    }
    
    /* image rules */
    /* .clientGridImg img.client-img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    } */
    
`
export default Clients
